exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".burst-reply-action[data-v-6d2ad08e]{cursor:pointer;position:relative;display:inline-table;width:90px;height:90px;margin-left:16px;border:1px solid #fff;border-radius:5px;overflow:hidden;background-color:#5451de;color:#fff;text-align:center;padding-top:1px}.burst-reply-action .plus-icon[data-v-6d2ad08e]{padding-bottom:5px}.burst-reply-action .action-description[data-v-6d2ad08e]{color:#fff;font-size:13px;text-align:center;padding:12px 5px}", ""]);

// exports
